<template>
    <list-export-payment
            :showSelect="false"
    >
    </list-export-payment>
</template>

<script>
import ListExportPayment from './base/listExportPaymentBase'

export default {
  name: 'test',
  props: {
    id: Number
  },
  // mixins: [myMixin],
  components: { ListExportPayment },
  data () {
    return {
      t: 1
    }
  },
  methods: {
  }
}
</script>

<style scoped>

</style>
